// General
import "./ekyc-submitted-dialog.scss";
import { forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateEkycSubmittedDialog } from "../../../../redux/store/dialogStore";
// Material UI
import { Dialog, Slide, useMediaQuery } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
// i18next
import { useTranslation } from "react-i18next";

const EkycSubmittedDialog = () => {
  // Redux variables
  const ekycSubmittedDialog = useSelector(
    (state) => state.dialog.ekycSubmittedDialog
  );
  const username = useSelector((state) => state.userCard.username);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateEkycSubmittedDialog(false));
  };

  return (
    <Dialog
      className={"custom-radius35-dialog"}
      fullScreen={false}
      open={ekycSubmittedDialog}
      TransitionComponenåt={Transition}
      onClose={onCloseDialog}
    >
      <div id="ekyc-submitted-dialog">
        <div className="check-icon-container">
          <div className="check-icon-outer">
            <CheckIcon className="check-icon" />
          </div>
        </div>

        <div style={{ padding: "10px" }} />

        <div className="ekyc-submitted-title">
          {t("verification.ekyc.document_submitted_dialog.title")}
        </div>

        <div style={{ padding: "10px" }} />

        <div className="ekyc-submitted-description">
          {t("verification.ekyc.document_submitted_dialog.description")}
        </div>

        <div style={{ padding: "20px" }} />

        <div className="ekyc-done-button" onClick={onCloseDialog}>
          {t("common.done")}
        </div>
      </div>
    </Dialog>
  );
};

export default EkycSubmittedDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
